export default[
    {
        path: '/usuario/cadastro',
        name: 'cadastro do usuários', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/usuario/lista',
        name: 'lista dos usuários', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/usuario/editar/:id',
        name: 'editar o usuario', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]